export enum LocationTypeEnum {
  MOTORWAY = "MOTORWAY",
  CLOSE_TO_MOTORWAY = "CLOSE_TO_MOTORWAY",
  NON_MOTORWAY = "NON_MOTORWAY",
  EMPTY = "EMPTY",
}
